import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { byteLength } from './byte-length.function';

export function byteMinValidator (min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const length: number = control.value ? byteLength(control.value) : 0;
        if (length < min) {
            return {minByte:{length, min}};
        }
        return null;
    };
}
